/**
 * String utility functions for the application
 */
export const useStringUtils = () => {
    /**
     * Capitalize names for display with proper title case
     * Converts "john smith" to "John Smith" and "JANE DOE" to "Jane Doe"
     */
    const capitalizeNameForDisplay = (name: string): string => {
        if (!name) return '';
        return name.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    /**
     * Normalize whitespace in strings
     */
    const normalizeString = (str: string): string => {
        return str.replace(/\s+/g, ' ').trim();
    };

    return {
        capitalizeNameForDisplay,
        normalizeString,
    };
};
